import { Container, ToRow, ToColumn, CheckBox } from './styles'
import React, { useState, useEffect } from 'react'
import api from '../../config/api'
import Loading from '../../components/Loading';
import { Typography } from "@material-ui/core";
import { AttachMoney, Money } from '@material-ui/icons';
import { toast } from 'react-toastify'
import {
    Button,
    TextField,
} from '@material-ui/core'
import { boolean } from 'yup';
import { isTemplateTail } from 'typescript';
function Results() {

    const [totalCapital, setTotalCapital] = useState('teste')
    const [totalMoney, setTotalMoney] = useState('teste')
    const [loading, setLoading] = useState(true)
    const [isCreatingCoupon, setIsCreatingCoupon] = useState(false)
    const [branchs, setBranchs] = useState<Branch[]>([])
    const [coupon, setCoupon] = useState('')
    const [products, setProducts] = useState<Product[]>([])
    const [selectedBranchs, setSelectedBranchs] = useState<{ id: number }[]>([])
    const [selectedPercentage, setSelectedPercentage] = useState('')
    const [selectedProducts, setSelectedProducts] = useState<{ id: number }[]>([])
    const [percentageCheckBoxValues, setPercentageCheckBoxValues] = useState([false, false, false])
    const [confimredConfig, setConfirmedConfig] = useState(false)
    const [coupons, setCoupons] = useState<Coupon[]>([])
    let [branchsString, setBranchsString] = useState('')
    let [productsString, setProductString] = useState('')

    interface Branch {
        id: number
        description: string
        created_at: string
    }

    interface Product {
        id: number
        name: string
        description: string
        value: number
        image: string
    }

    interface Coupon {
        value: string
        branchs: string
        products: string
        percentage: string
    }

    useEffect(() => {
        getResults()
        getBranchs()
        getProducts()
        getCoupons()
    }, [])

    useEffect(() => {

    }, [coupons])


    async function getCoupons() {
        const response = await api.get('/coupons')
        setCoupons(response.data.coupons)
    }

    async function getProducts() {
        const response = await api.get('/products')
        setProducts(response.data.products)
    }
    
    async function getBranchs() {
        const response = await api.get('/branchs')
        setBranchs(response.data.branchs)
    }

    async function getResults() {
        const totalCapitalRes = await api.get('/orders/totalcapital')
        const totalMoneyRes = await api.get(`/orders/totalmoney`)
        setTotalCapital(totalCapitalRes.data[0].sum)
        setTotalMoney(totalMoneyRes.data[0].sum)
        setLoading(false)
    }


    function setPercentage(percentage: string, auxPercentageValues: any) {
        setPercentageCheckBoxValues(auxPercentageValues)
        setSelectedPercentage(percentage)
    }

    function setBranch(auxId: number) {
        console.log(selectedBranchs)
        const index = selectedBranchs.findIndex(item => item.id == auxId)
        if (index == -1) {
            let aux = { id: auxId }
            setSelectedBranchs(selectedBranchs => [...selectedBranchs, aux])
            console.log('coloca')
        } else {
            let aux = selectedBranchs
            aux[index].id = 0
            setSelectedBranchs(aux)
        }
    }

    function setProduct(auxId: number) {
        console.log(selectedProducts)
        const index = selectedProducts.findIndex(item => item.id == auxId)
        if (index == -1) {
            let aux = { id: auxId }
            setSelectedProducts(selectedProducts => [...selectedProducts, aux])
            console.log('coloca')
        } else {
            let aux = selectedProducts
            aux[index].id = 0
            setSelectedProducts(aux)
        }
    }

    async function handleCoupon() {
        await generateCoupon(5)
        setIsCreatingCoupon(true)
    }

    async function generateCoupon(length: number) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        setCoupon(result)
        return
    }


    async function handleCouponConfig() {
        await selectedBranchs.forEach(element => {
            branchsString = '-' + element.id.toString() + '-' + branchsString
        });
        await selectedProducts.forEach(element => {
            productsString = '-' + element.id.toString() + '-' + productsString
        });
        await setBranchsString(branchsString)
        await setProductString(productsString)
        if (coupon == '' || branchsString == '' || productsString == '' || selectedPercentage == '') {
            toast.error('Selecione configurações válidas para a criação do cupom!')
            return
        }
        setConfirmedConfig(true)
    }


    async function createCoupon() {
        console.log({ value: coupon, branchs: branchsString, products: productsString, percentage: selectedPercentage })


        try {
            const responseCoupon = await api.post(`/coupons/create`, { value: coupon, branchs: branchsString, products: productsString, percentage: selectedPercentage })
            toast.success("Código gerado com sucesso!")
            document.location.reload();
            setIsCreatingCoupon(false)
        } catch (error) {
            toast.error("Ocorreu um erro ao gerar seu código!")
        }
    }


    async function deleteCoupon(couponValue: string) {
        try {
            const responseCoupon = await api.delete(`/coupons/deleteByValue`, {
                data: {
                    value: couponValue
                }
            })
            toast.success("Cupom deletado com sucesso!")
            document.location.reload();
        } catch (error) {
            toast.error('Ocorreu um erro deletar o cupom!')
        }

    }

    /*
                                    <ToRow>
                                        <CheckBox checked={percentageCheckBoxValues[0]} type={'checkbox'} onChange={() => setPercentage('30', [true, false, false])} style={{ margin: 3 }}></CheckBox>
                                        <div>30 %</div>
                                    </ToRow>
                                    <ToRow>
                                        <CheckBox checked={percentageCheckBoxValues[1]} type={'checkbox'} onChange={() => setPercentage('40', [false, true, false])} style={{ margin: 3 }}></CheckBox>
                                        <div>40%</div>
                                    </ToRow>
    */

    return (
        <Container>
            {
                loading ?
                    <Loading />
                    :
                    <>
                        <Typography variant="h4" style={{ fontWeight: 440 }}>
                            Resultados Sicredi Store
                        </Typography>
                        <ToRow>
                            <AttachMoney style={{ fontSize: 45 }} />
                            <Typography variant="h4" style={{ fontWeight: 200 }}>
                                - Capital: {totalCapital} R$
                            </Typography>
                        </ToRow>
                        <ToRow>
                            <Money style={{ fontSize: 45 }} />
                            <Typography variant="h4" style={{ fontWeight: 200 }}>
                                - Dinheiro: {totalMoney} R$
                            </Typography>
                        </ToRow>
                        <Typography variant="h4" style={{ fontWeight: 440, marginTop: 50 }}>
                            Descontos
                        </Typography>
                        <ToColumn>
                            <Button
                                onClick={handleCoupon}
                                variant="contained"
                                type="submit"
                                color="secondary"
                                className="submit-button"
                                style={{
                                    width: 300,
                                    height: 50
                                }}>
                                Configurar um Novo cupom de desconto
                            </Button>
                            {isCreatingCoupon ?
                                <>
                                    <Typography variant="h4" style={{ fontWeight: 150, marginTop: 50 }}>
                                        Seu Código de cupom é: <strong>{coupon}</strong>
                                    </Typography>
                                    <Typography variant="h4" style={{ fontWeight: 440, marginTop: 50 }}>
                                        Selecione um percentual de desconto:
                                    </Typography>
                                    <ToRow>
                                        <CheckBox checked={percentageCheckBoxValues[2]} type={'checkbox'} onChange={() => setPercentage('50', [false, false, true])} style={{ margin: 3 }}></CheckBox>
                                        <div>50%</div>
                                    </ToRow>
                                    <Typography variant="h4" style={{ fontWeight: 440, marginTop: 50 }}>
                                        Selecione as agencias onde o cupom será válido:
                                    </Typography>
                                    {
                                        branchs
                                            .map((branch, index) => (
                                                <>
                                                    <div id={branch.id.toString()}>
                                                        <CheckBox id={branch.id.toString()} type={'checkbox'} onChange={() => setBranch(branch.id)}></CheckBox> {branch.id} - {branch.description}
                                                    </div>
                                                </>
                                            ))
                                    }
                                    <Typography variant="h4" style={{ fontWeight: 440, marginTop: 50 }}>
                                        Selecione os produtos que o código será aplicável:
                                    </Typography>
                                    {
                                        products
                                            .map((product) => (
                                                <>
                                                    <div id={product.id.toString()}><CheckBox type={'checkbox'} onChange={() => setProduct(product.id)}></CheckBox> {product.name} - {product.description}

                                                    </div>
                                                </>
                                            ))
                                    }
                                    <Button
                                        onClick={handleCouponConfig}
                                        variant="contained"
                                        type="submit"
                                        color="secondary"
                                        className="submit-button"
                                        style={{
                                            width: 300,
                                            height: 50
                                        }}>
                                        Confirmar configurações
                                    </Button>
                                    {confimredConfig ?
                                        <Button
                                            onClick={createCoupon}
                                            variant="contained"
                                            type="submit"
                                            color="secondary"
                                            className="submit-button"
                                            style={{
                                                width: 300,
                                                height: 50
                                            }}>
                                            Finalizar
                                        </Button> :
                                        <div>Confirme suas configurações para continuar</div>
                                    }

                                </>
                                :
                                <>
                                    <Typography variant="h4" style={{ fontWeight: 440, marginTop: 50 }}>
                                        Cupons de desconto ativos:
                                    </Typography>
                                    {coupons.length > 0 ?
                                        coupons
                                            .map((coupon) => (
                                                <>
                                                    <ToRow>
                                                        <div> Cupom de desconto valor: <strong>{coupon.value}</strong> ativo nas unidades: <strong>{coupon.branchs}</strong> para os produtos de id: <strong>{coupon.products}</strong> com percentual de <strong>{coupon.percentage} %</strong></div>
                                                        <Button
                                                            onClick={() => deleteCoupon(coupon.value)}
                                                            variant="contained"
                                                            type="submit"
                                                            color="secondary"
                                                            className="submit-button"
                                                            style={{
                                                                width: 200,
                                                                height: 20,
                                                                margin: 5
                                                            }}>
                                                            Deletar Cupom
                                                        </Button>
                                                    </ToRow>
                                                </>
                                            ))
                                        :
                                        <>Nenhum cupom de desconto ativo</>
                                    }
                                </>
                            }
                        </ToColumn>
                    </>
            }
        </Container>
    );
}

export default Results